import {ErrorPriority} from "../../enums/ErrorPriority";
import {Entity} from "../Entity";
import {NavigationVisitor} from "../navigation/NavigationVisitor";
import {Tenant} from "../tenant/Tenant";
import {TenantApplication} from "../tenant/TenantApplication";

export abstract class LoggableEntity implements Entity {
    id: string;
    tenant: Tenant;
    application: TenantApplication;
    isSolved: boolean;
    errorPriority: ErrorPriority;

    constructor(id: string, tenant: Tenant, application: TenantApplication, errorPriority: ErrorPriority, isSolved: boolean) {
        this.id = id;
        this.tenant = tenant;
        this.application = application;
        this.errorPriority = errorPriority;
        this.isSolved = isSolved;
    }

    public get fullApplicationName(): string {
        return this.application.friendlyName ? "[" + this.application.name + "] " + this.application.friendlyName : this.application.name;
    }

    public abstract get descriptionKey(): string;

    abstract accept(visitor: NavigationVisitor, openNewTab?: boolean): void;
}
